import ITestControllerInitializationStrategy from './ITestControllerInitializationStrategy';
import TestController from '../TestController';
import AdaptiveNavigationController from '../navigation/AdaptiveNavigationController';
import NavigationApiController from '../navigation/api/NavigationApiController';
import StateController from '../state/StateController';

class AdaptiveTestControllerInitializationStrategy implements ITestControllerInitializationStrategy {
  // Override
  initialize(qtiSessionId: string, sessionId: string, formId: string, testController: TestController): Promise<void> {
    return new Promise<void>((resolve) => {
      testController.stateController = new StateController();

      testController.navigationController = new AdaptiveNavigationController(
        new NavigationApiController(qtiSessionId),
        testController
      );

      resolve();
    });
  }
}

export default AdaptiveTestControllerInitializationStrategy;
